import isUndefined from 'lodash/isUndefined';

export function saveEmail(email: string): void {
  try {
    if (!isUndefined(localStorage)) localStorage.setItem('email', email);
  } catch (_err) {
    // browser is in private mode
  }
}

export function getEmail(): string {
  try {
    return isUndefined(localStorage) ? '' : localStorage.getItem('email') || '';
  } catch (_err) {
    // browser is in private mode
    return '';
  }
}
